import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/active_job/'

export default {
  getDriverActiveJobs (baseUrl, driverId) {
    return axios.get(baseUrl + URL + `${driverId}/list`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  updateDriverActiveJobsPriority (baseUrl, data) {
    return axios.post(baseUrl + URL + `${data.driverId}/update_priority`, data.data).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
